var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-32 0 448 448",
    fill: "#B18F6B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 426.667969h384v21.332031h-384zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m352 437.332031h-21.332031v-362.664062h-277.335938v362.664062h-21.332031v-384h320zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m96 128h74.667969v21.332031h-74.667969zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m213.332031 128h74.667969v21.332031h-74.667969zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m96 202.667969h74.667969v21.332031h-74.667969zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m213.332031 202.667969h74.667969v21.332031h-74.667969zm0 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m96 277.332031h74.667969v21.335938h-74.667969zm0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m213.332031 277.332031h74.667969v21.335938h-74.667969zm0 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m298.667969 64h-21.335938v-42.667969h-170.664062v42.667969h-21.335938v-64h213.335938zm0 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m96 352h74.667969v21.332031h-74.667969zm0 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m213.332031 352h74.667969v21.332031h-74.667969zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.afec1ff97caea4de15f6f6860aea85d9.svg";
export { ForwardRef as ReactComponent };